import { z } from 'zod';

export const AssemblyTemplateItemSchema = z.object({
  id: z.string().uuid(),
  assembly_template_id: z.string().uuid(),
  name: z.string(),
  rate: z.number(),
  sort_order: z.number().int(),
});

export const CreateAssemblyTemplateItemSchema = z.object({
  name: z.string().min(1, 'Item name is required'),
  rate: z.number().default(0),
  sort_order: z.number().int().default(0),
});

export const AssemblyTemplateSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  name: z.string(),
  unit_type: z.string(),
  description: z.string().nullable(),
  active: z.boolean(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
  items: z.array(AssemblyTemplateItemSchema).optional(),
});

export const CreateAssemblyTemplateSchema = z.object({
  code: z.string().min(1, 'Code is required'),
  name: z.string().min(1, 'Name is required'),
  unit_type: z.string().default('LF'),
  description: z.string().nullable().optional(),
  active: z.boolean().default(true),
  items: z.array(CreateAssemblyTemplateItemSchema).default([]),
});

export const UpdateAssemblyTemplateSchema = CreateAssemblyTemplateSchema.partial();

export type AssemblyTemplate = z.infer<typeof AssemblyTemplateSchema>;
export type AssemblyTemplateItem = z.infer<typeof AssemblyTemplateItemSchema>;
export type CreateAssemblyTemplate = z.infer<typeof CreateAssemblyTemplateSchema>;
export type CreateAssemblyTemplateItem = z.infer<typeof CreateAssemblyTemplateItemSchema>;
export type UpdateAssemblyTemplate = z.infer<typeof UpdateAssemblyTemplateSchema>;
